export default {
	meta: {
		title: 'Patient',
		description: 'Patient'
	}
};
